module.exports = __webpack_public_path__ + "static/media/LK__Radio Button Uncheck.79f7dc6e.svg";